import Privacy from '@module/privacy';

export const init = () => {
  Privacy.configure();
};
